import React from 'react';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

interface Props {
  children: React.ReactNode;
}

export const FooterButtonGroup: React.FC<React.PropsWithChildren<Props>> = ({ children }) => {
  return <Container>{children}</Container>;
};

const Container = styled.div`
  border: 1px solid ${vars.v3Color.gray150};
  display: flex;
  justify-content: center;
  padding: 12px 0;
  border-radius: 8px;
  height: 40px;

  > * {
    display: flex;
    justify-content: center;
    width: 50%;
  }

  > * + * {
    position: relative;

    &::before {
      content: '';
      border-left: 1px solid ${vars.v3Color.gray150};
      position: absolute;
      top: 0;
      left: 0;
      width: 0;
      height: 15px;
    }
  }

  figure.icon {
    margin-right: 2px;
  }

  span {
    line-height: 16px;
    cursor: pointer;
  }
`;
